import { mediaQueries } from '@eti/styles';
import { AD_FORM_SCRIPTS } from '../constants/resultConstants';

const createAdFormBannersScriptTag = () => {
  const scriptTag = document.createElement('script');
  scriptTag.setAttribute('src', '//s1.adform.net/banners/scripts/adx.js');
  scriptTag.setAttribute('async', 'true');
  scriptTag.setAttribute('defer', 'true');
  return scriptTag;
};

const createAdFormData = (mid, search) => {
  const {
    continentCode: destinationContinentCode,
    continentName: destinationContinentName,
    countryName: destinationCountryName,
    countryCode: destinationCountryCode,
    cityName: destinationCityName,
    cityCode: destinationCityCode,
  } = search.destination;

  const { cityName: originCity, cityCode: originCityCode } = search.origin;

  const { carrierCodes, carrierNames } = search;

  const searchData = `continent:${destinationContinentName},
    continentcode:${destinationContinentCode},
    country:${destinationCountryName},
    destinationcountrycode:${destinationCountryCode},
    city:${destinationCityName},
    citycode:${destinationCityCode},
    origincity:${originCity},
    origincitycode:${originCityCode},
    carrier:${carrierNames?.length ? carrierNames.toString() : 0},
    carriercode:${carrierCodes?.length ? carrierCodes.toString() : 0};`;

  return `adx.adform.net/adx/?mid=${mid}&mkv=${searchData}`;
};

const createAdFormScriptTag = (mid, search) => {
  const searchData = createAdFormData(mid, search);
  const adFormScriptTag = document.createElement('script');
  adFormScriptTag.setAttribute('style', 'display: none;');
  adFormScriptTag.setAttribute('data-adfscript', searchData);
  return adFormScriptTag;
};

export const addAdFormScriptTags = (documentElement, mid, search) => {
  if (!document.getElementById(AD_FORM_SCRIPTS)) {
    const styles = `
      padding-top: 20px;

      @media ${mediaQueries.large.up} {
        padding-top: 30px;
      }
    `;
    const scriptsWrapper = document.createElement('div');
    scriptsWrapper.setAttribute('id', AD_FORM_SCRIPTS);
    scriptsWrapper.setAttribute('data-testid', AD_FORM_SCRIPTS);
    scriptsWrapper.setAttribute('style', styles);
    scriptsWrapper.appendChild(createAdFormBannersScriptTag());
    scriptsWrapper.appendChild(createAdFormScriptTag(mid, search));
    if (documentElement?.children) {
      documentElement.children[0].appendChild(scriptsWrapper);
    }
  }
};
